import { UserAPI } from "@/api/user";
import { Selectors as UserSelectors } from "@/store/user/selectors";
import { Selectors as PrefsSelectros } from "@/store/prefs/selectors";
import { Actions as PrefsActions } from "@/store/prefs/slice";
import merge from "lodash/merge";
import cloneDeep from "lodash/cloneDeep";
import { getReduxState, getReduxStore } from "@/store";
import Cookies from "js-cookie";
import { IS_BROWSER, IS_SERVER } from "@/misc/constants";
import { tUserPrefs } from "@/types/users";
import { tInitialScreen } from "@/config";
import { tMastersSearchLocation } from "@/types";
import { GeoService } from "../geo";
import ee from "@/utils/ee";

const getAllPrefs = () => {
  return PrefsSelectros.getAllPrefs(getReduxStore()!.getState());
};
if (IS_BROWSER) {
  ee!.on("masters-search-loc-pref-changed", (loc: tMastersSearchLocation) => {
    console.log(loc);
    UserPrefsService.changeMastersSearchLocation(loc);
  });
}
const updatePrefs = async (partial: Partial<tUserPrefs>) => {
  if (IS_SERVER) return;
  const reduxStore = getReduxStore()!;

  const id = UserSelectors.getUserId(getReduxState());
  const oldPrefs = getAllPrefs();
  const newPrefs = merge(cloneDeep(oldPrefs), partial);
  // optimistic update
  reduxStore.dispatch(PrefsActions.replacePrefs(newPrefs));
  if (id) {
    try {
      await UserAPI.updateById(id, { prefs: newPrefs });
    } catch (e) {
      // rollback
      reduxStore.dispatch(PrefsActions.replacePrefs(oldPrefs));
      throw e;
    }
  } else {
    Cookies.set("app-prefs", JSON.stringify(newPrefs), {
      expires: 365,
    });
  }
};
export const UserPrefsService = {
  getDailySleepMinutes() {
    const state = getReduxState();
    if (state) return PrefsSelectros.getDailySleepMinutes(state);
  },
  getAllPrefs,
  getTodoCompletionProbTipVisibility() {
    const state = getReduxState();
    if (state) return PrefsSelectros.getTodoCompletionProbTipVisibility(state);
  },
  getMastersSearchLocation() {
    const state = getReduxState();
    if (state) return PrefsSelectros.getMastersSearchLocation(state);
  },
  updatePrefs,
  async changeInitialScreen(initial_screen: tInitialScreen) {
    await updatePrefs({ initial_screen });
  },
  async changeDayOverallStatsNotification(
    day_overall_stats_notification: tUserPrefs["day_overall_stats_notification"],
  ) {
    await updatePrefs({ day_overall_stats_notification });
  },
  async changeTodoCompletionProbTipVisibility(
    todo_completion_prob_tip: boolean,
  ) {
    await updatePrefs({ todo_completion_prob_tip });
  },
  async changeDailySleep(daily_sleep: number) {
    await updatePrefs({ daily_sleep });
  },
  async changeMastersSearchLocation(
    masters_search_loc: tMastersSearchLocation,
  ) {
    await updatePrefs({ masters_search_loc });
  },
  async detectUserLocationAndUseItForMastersSearchPref() {
    const loc = await GeoService.detectCurrentLocation();
    if (loc) {
      await updatePrefs({
        masters_search_loc: {
          coords: { lat: loc.lat, lng: loc.lng },
          label: loc.city || loc.name || loc.fullName,
        },
      });
    }
    return loc;
  },
};
